export const ProductIntegration = (): JSX.Element => <h1>Integration</h1>;
